export const custmizesku = {
    finalring: {
        sku: "finalring",
        'sku#': "final enagement ring",
        url: "final-ring"
    },
    finalpendant: {
        sku: "finalpendant",
        'sku#': "final pendant",
        url: "final-pendant"
    },
};